//-- React Standard
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import {
    Table,
} from 'reactstrap';
import config from '../../config';
//-- Custom
import { withStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { apiConstants } from '../../_constants/api.constants';
import Button from '@material-ui/core/Button';

// import Pagination from "../Common/Pagination/Pagination";
// import PageLimit from "../Common/PageLimit/PageLimit";
// import ViewPopup from "../Common/Popup/ViewPopup";
// import { userActions } from "../../_actions";
import { orderActions, shopActions, userActions } from "../../_actions";
//import { socketService } from "../../_services";
import { commonFunctions } from "../Common/common";

import openSocket from 'socket.io-client';
const socket = openSocket('http://localhost:3000/');

// const socket = io('http://3.129.66.173:3000/');
//import { Event } from 'react-socket-io';
const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    }
});

class CurrentOrderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            orderData: [],
            perPage: 10,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            popupType: '',
            addButton: false,
            shopKeeperAdd: false,
            shopKeeperData: [],
            acceptOrder: false,
            isShopkeeper: false,
            assignDeliveryBoy: false,
            assignDeliveryBoyError: '',
            assignDeliveryBoySuccess: '',
            getUsersList: [],
            orderId: '',
            selectedOrderStatus: '',
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        this.getOrdersConditionally(this.state.perPage, 1);
        socket.on('orderCreateInit', (data) => {
            this.setState({ orderData: [] })
            this.getOrdersConditionally(this.state.perPage, 1);
        });
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getAllOrders) {
            if (props.getAllOrders.orderList !== undefined &&
                props.getAllOrders.orderList.data !== undefined &&
                props.getAllOrders.orderList.data.allData !== undefined) {

                if (this.state.triggerGetOrder === true) {
                    let orders = props.getAllOrders.orderList.data;
                    let oldOrder = [...this.state.orderData, ...orders.allData];
                    this.setState({
                        triggerGetOrder: false,
                        orderData: oldOrder,
                        totalPage: orders.pagination.totalPages,
                        totalDataCount: orders.pagination.totalCount,
                    })
                }
            }
        }

        //when order marked accepted
        if (props.markOrderAccepted) {
            if (
                props.markOrderAccepted.accepted !== undefined &&
                props.markOrderAccepted.accepted &&
                this.state.acceptOrder === true
            ) {
                this.setState({ acceptOrder: false, orderData: [] });
                this.getOrdersConditionally(this.state.perPage, 1);
            }
        }

        //-- get Delivery Boy list
        if (props.getUsersList) {
            if (props.getUsersList.getUsersList) {
                if (props.getUsersList.getUsersList.data) {

                    this.setState({
                        getUsersList: props.getUsersList.getUsersList.data.data,
                    })
                }
            }
        }
    }

    //get orders common
    getOrdersConditionally = (perpage, pageNo) => {
        const { dispatch } = this.props;
        let userData = JSON.parse(sessionStorage.getItem('user'));

        let postData = {};
        postData.page = pageNo;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = perpage;
        if (userData.role_type[0] == 'shopkeeper') {
            postData.shopkeeperId = userData._id;
            postData.merchantShopId = userData.merchantShopId;
            this.setState({ isShopkeeper: true })
        }

        this.setState({ triggerGetOrder: true })

        dispatch(orderActions.getAllOrders(apiConstants.GET_SHOPKEEPER_CURRENT_ORDERS, postData));
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
    }


    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(shopActions.getAllShopKeeper(apiConstants.GET_SHOP_AND_SHOPKEEPER, postData));
        this.setState({ perPage: parseInt(e.target.value) })
    }
    /*
    * searchOrders - User can search data from the database and it will appear
    */
    // searchOrders(keyword, perpage, pageNo) {
    //     const { dispatch } = this.props;
    //     let userData = JSON.parse(sessionStorage.getItem('user'));

    //     let postData = {};
    //     postData.page = pageNo;
    //     postData.orderBy = "id";
    //     postData.orderByAscDesc = "ASC";
    //     postData.perPage = perpage;
    //     if (userData.role_type[0] == 'shopkeeper') { postData.shopkeeperId = userData._id; }

    //     dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));


    //     if (keyword.target.value !== '') {
    //         postData.search = keyword.target.value;
    //         dispatch(orderActions.getAllOrders(apiConstants.SEARCH_ORDER, postData));
    //     } else {
    //         dispatch(orderActions.getAllOrders(apiConstants.GET_ALL_ORDERS, postData));
    //     }
    // }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    // popupOpen = (advertisments, type, btnClick) => {
    //     //-- check add button clicked
    //     if (btnClick === 'addButton') {
    //         this.setState({ addButton: true });
    //         this.setState({ popupType: 'AddShopkeeper' })
    //     }
    //     //this.setState({ advertisments, [type]: true })
    // };


    /*
    *   Close the popup
    */
    // popupClose = (type) => {
    //     this.setState({
    //         advertisments: {
    //             title: '',
    //             type: '',
    //             advertisment_image: '',
    //         },
    //         addButton: false,
    //         [type]: false
    //     });
    // };

    requestMoreOrder = (curPage) => {
        this.setState({ currentPage: this.state.currentPage + 1 })
        this.getOrdersConditionally(this.state.perPage, curPage + 1);
    }

    //redirect to order details
    viewOrderDetails = (orderId) => {
        const { history } = this.props;
        let url = '/order-details/' + orderId;
        history.push(url);
    }


    //-- accept a order
    acceptTheOrder = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ acceptOrder: true })

        var obj = {}
        obj.orderId = orderId;
        //if(purchaseType == "pickup"){ obj.orderStatus = "preparing"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_ACCEPTED, obj));

    }

    // //-- reject a order by shopkeeper
    rejectTheOrder = (orderId) => {
        const { dispatch } = this.props;

        var obj = {}
        obj.orderId = orderId;
        dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_REJECTED, obj));

    }

    //on change set field values
    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    //-- Assign to delivery Boy
    assignToDeliveryBoy = (orderId, orderStatus) => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "_id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.role = 'deliveryBoy';

        dispatch(userActions.getUsersList(apiConstants.GET_ALL_USERS, postData));
        this.setState({
            assignDeliveryBoy: !this.state.assignDeliveryBoy,
            orderId: orderId,
            selectedOrderStatus: orderStatus
        });
    }

    //close add category popup
    closeDeliveryBoyPopup = () => {
        this.setState({
            assignDeliveryBoy: false
        });
    }

    //-- assign delivery boy
    handleSubmitDeliveryBoy = () => {
        const { dispatch } = this.props;
        this.setState({ assignDeliveryBoyError: '' });
        const { deliveryBoyId, outsiderDeliveryBoy } = this.state;
        if ((deliveryBoyId === undefined || deliveryBoyId === 'select') && (outsiderDeliveryBoy === undefined || outsiderDeliveryBoy === '')) { this.setState({ assignDeliveryBoyError: 'Delivery Boy or Outsider Delivery Boy required!!' }) }
        else if ((deliveryBoyId !== null && deliveryBoyId !== 'select') && (outsiderDeliveryBoy !== undefined && outsiderDeliveryBoy !== '')) {
            this.setState({ assignDeliveryBoyError: 'Either select Delivery Boy or Outsider Delivery Boy!!' })
        } else {

            this.setState({ assignDeliveryBoy: false })
            const postData = {};
            postData.deliveryBoyId = deliveryBoyId;
            postData.outsiderDeliveryBoy = outsiderDeliveryBoy;
            postData.orderId = this.state.orderId;
            postData.selectedOrderStatus = this.state.selectedOrderStatus;

            dispatch(orderActions.assignDeliveryBoy(apiConstants.ASSIGN_DELIVERY_BOY, postData));
        }
    }

    //-- mark order prepaired
    orderPrepaired = (orderId, purchaseType) => {
        const { dispatch } = this.props;
        this.setState({ acceptOrder: true })

        var obj = {}
        obj.orderId = orderId;
        if (purchaseType == "pickup") { obj.orderStatus = "preparing"; }
        dispatch(orderActions.markOrderAccepted(apiConstants.MARK_ORDER_PREPAIRED, obj));
    }

    //-- pickuped by delivery boy
    pickupByDeliveryboy = (orderId) => {
        const { dispatch } = this.props;

        var obj = {}
        obj.orderId = orderId;
        dispatch(orderActions.markOrderAccepted(apiConstants.PICKED_UP_BY_DELIVERY_BOY, obj));
    }

    //-- Order completed successfully by Shopkeeper 
    completeTheOrder = (orderId) => {
        const { dispatch } = this.props;
        this.setState({ acceptOrder: true })

        var obj = {}
        obj.orderId = orderId;
        dispatch(orderActions.markOrderAccepted(apiConstants.ORDER_COMPLETED_BY_SHOPKEEPER, obj));
    }

    //-- Product Recieved after order rejected by customer
    productRecieved = (orderId) => {
        const { dispatch } = this.props;

        var obj = {}
        obj.orderId = orderId;
        dispatch(orderActions.markOrderAccepted(apiConstants.PRODUCT_RECEIEVED_AFTER_ORDER_REJECT_BY_CUSTOMER, obj));
    }

    //-- Once order canceled by customer, shopkeeper can accept
    acceptCancelation = (orderId) => {
        const { dispatch } = this.props;

        var obj = {}
        obj.orderId = orderId;
        dispatch(orderActions.markOrderAccepted(apiConstants.CANCELATION_ORDER_ACCEPTED_BY_SHOPKEEPER, obj));
    }

    //-- Main function
    render() {
        const { classes } = this.props;
        const { siteConstants } = this.props.language;
        const dateFormat = { year: 'numeric', month: 'long', day: 'numeric' };
        const timeFormat = { hour: '2-digit', minute: '2-digit' };
        return (
            <Fragment>
                {/* <Event event='eventName' handler={this.onMessage} />             */}
                <Table hover responsive className="table-outline mb-0 d-none d-sm-table">
                    <thead className="thead-light">

                        <tr>
                            {/* <th className="text-center"><i className="icon-people"></i></th> */}
                            <th>{siteConstants.LABEL_CUSTOMER}</th>
                            <th className="text-center">{siteConstants.GEN_ORDER_CODE}</th>
                            <th>{siteConstants.LABEL_ORDER_ITEMS}</th>
                            <th className="text-center">{siteConstants.LABEL_PAYMENT}</th>
                            <th>{siteConstants.LABEL_DATE}</th>
                            <th>{siteConstants.LABEL_ORDER_TYPE}</th>
                            <th>{siteConstants.LABEL_STATUS}</th>
                            <th>{siteConstants.LABEL_ACTION}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.orderData != undefined &&
                                this.state?.orderData?.length > 0 ?
                                this.state.orderData.map((thisOrder, index) => {
                                    let shopTitle = 'NA';

                                    // if (thisOrder.shopData !== undefined) {
                                    //     shopTitle = thisOrder.shopData.map((shop, index) => {
                                    //         return shop.title;
                                    //     })
                                    // }
                                    let orderDate = new Date(thisOrder.createdAt);
                                    return (

                                        <tr>
                                            {/* <td className="text-center">
                                        <div className="avatar">
                                        { thisOrder.productData!== undefined && thisOrder.productData[0] !== undefined && thisOrder.productData[0].mainImage !== undefined && thisOrder.productData[0].mainImage ?
                                            <img src={`${config.imgPath}` + '/uploads/products/' + thisOrder.productData[0].mainImage } style={{width:"50px", height:"50px"}}/>
                                            :
                                            <img src={`${config.imgPath}` + '/uploads/products/default-product.png'  } />
                                        }
                                        </div>
                                    </td> */}
                                            <td>
                                                <div onClick={(e) => this.viewOrderDetails(thisOrder._id)} style={{ fontWeight: "bold", cursor: "pointer" }}>{thisOrder?.usersData[0]?.firstname}&nbsp;{thisOrder?.usersData[0]?.lastname}</div>
                                                <div className="small text-muted">
                                                    {thisOrder.address.roomNumber}&nbsp;{thisOrder.address.buildingName}

                                                </div>
                                                <div>
                                                    {
                                                        thisOrder.usersData[0] !== undefined ?
                                                            thisOrder.usersData[0].mobile_number
                                                            : ""
                                                    }
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <a href="javascript:void(0)" onClick={(e) => this.viewOrderDetails(thisOrder._id)}>{thisOrder.orderNumber}</a>
                                            </td>
                                            <td>
                                                <div className="clearfix">
                                                    {
                                                        thisOrder.ordersData !== undefined ?
                                                            thisOrder.ordersData.length
                                                            : ""
                                                    }
                                                </div>
                                            </td>
                                            <td>{commonFunctions.paymentStatus(thisOrder.paymentStatus)}</td>
                                            <td>
                                                {/* <div className="small text-muted">Last login</div> */}
                                                <strong>{orderDate.toLocaleString("en-US", dateFormat) + " At " + orderDate.toLocaleString("en-US", timeFormat)}</strong>
                                            </td>
                                            <td>{thisOrder.purchaseType}</td>
                                            <td>{commonFunctions.orderStatus(thisOrder.status, siteConstants)}</td>
                                            <td>
                                                {
                                                    thisOrder.status == "pending" && this.state.isShopkeeper == true ?
                                                        <><button className="redBtn" onClick={(e) => this.acceptTheOrder(thisOrder._id, thisOrder.purchaseType)}>Accept Order</button> or <button className="redBtn" onClick={(e) => this.rejectTheOrder(thisOrder._id)}>Reject Order</button>
                                                        </>
                                                        : ""
                                                }
                                                {/* {
                                                    (thisOrder.status == "accepted_by_shopkeeper" || thisOrder.status == "rejected_by_delivery_boy") && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.assignToDeliveryBoy(thisOrder._id)}>Assign to Delivery Boy</button>
                                                        : ""
                                                } */}

                                                {
                                                    thisOrder.status == "accepted_by_shopkeeper" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.orderPrepaired(thisOrder._id, thisOrder.purchaseType)}>Order Prepaired</button>
                                                        : ""
                                                }
                                                {
                                                    (thisOrder.status == "prepared" || thisOrder.status == "rejected_by_delivery_boy" || thisOrder.status == "rental_returning_rejected_by_delivery_boy") && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.assignToDeliveryBoy(thisOrder._id, thisOrder.status)}>Assign to Delivery Boy</button>
                                                        : ""
                                                }
                                                {
                                                    (thisOrder.status == "assign_to_delivery_boy" || thisOrder.status == "rental_returning_assign_to_delivery_boy") && this.state.isShopkeeper == true ?
                                                        "Waiting Time"
                                                        : ""
                                                }

                                                {
                                                    thisOrder.status == "accepted_by_delivery_boy" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.pickupByDeliveryboy(thisOrder._id)}>Pickup by Delivery Boy</button>
                                                        : ""
                                                }

                                                {
                                                    thisOrder.status == "rental_returning_accepted_by_delivery_boy" && this.state.isShopkeeper == true ?
                                                        "Delivery Boy not picked up yet"
                                                        : ""
                                                }

                                                {
                                                    thisOrder.status == "picked_up_by_delivery_boy" && this.state.isShopkeeper == true ?
                                                        "Order not deliverd yet by Delivery Boy"
                                                        : ""
                                                }

                                                {
                                                    thisOrder.status == "delivered" && this.state.isShopkeeper == true ?
                                                        "Customer not send any return request yet"
                                                        : ""
                                                }
                                                {
                                                    thisOrder.status == "rental_returning_request_by_user" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.assignToDeliveryBoy(thisOrder._id, thisOrder.status)}>Assign to Delivery Boy</button>
                                                        : ""
                                                }
                                                {
                                                    thisOrder.status == "rental_returning_deposit_to_shopkeeper" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.completeTheOrder(thisOrder._id)}>Complete the Order</button>
                                                        : ""
                                                }
                                                {
                                                    thisOrder.status == "canceled_by_customer" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.acceptCancelation(thisOrder._id)}>Accept Cancelation</button>
                                                        : ""
                                                }
                                                {
                                                    thisOrder.status == "order_rejected_by_customer_on_deilvery_time" && this.state.isShopkeeper == true ?
                                                        <button className="redBtn" onClick={(e) => this.productRecieved(thisOrder._id)}>Product recieved after order rejection</button>
                                                        : ""
                                                }
                                            </td>
                                        </tr>
                                    )
                                }) : "No Orders availables"

                        }

                        <tr>
                            {
                                this.state.totalPage + 1 === this.state.currentPage ? "" :
                                    <td colSpan="8" onClick={(e) => this.requestMoreOrder(this.state.currentPage)} style={{ textAlign: "center", cursor: "pointer", fontWeight: "bold" }}>Load More </td>
                            }

                        </tr>
                    </tbody>
                </Table>

                {/* add category popup */}
                <Dialog
                    open={this.state.assignDeliveryBoy}
                    aria-labelledby="category-title"
                    aria-describedby="save-category-description"
                >
                    <DialogTitle id="crop-image-dialog-title" className={classes.root}>Add Delivery Boy</DialogTitle>
                    <DialogContent className={classes.contentRoot}>
                        <div className="col-md-12 col-xs-12">
                            <p style={{ color: 'red' }}>{this.state.assignDeliveryBoyError}</p>
                            <p style={{ color: 'green' }}>{this.state.assignDeliveryBoySuccess}</p>
                        </div>
                        <div class="row">
                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>Delivery Boy</label>
                                    {
                                        <select
                                            className="form-control"
                                            onChange={(e) => this.onChange(e)}
                                            name="deliveryBoyId"
                                        >
                                            <option value="select">Select Delivery Boy</option>
                                            {
                                                this.state.getUsersList != undefined &&
                                                    this.state.getUsersList.length > 0 ?
                                                    this.state.getUsersList.map((users, index) => {
                                                        // let stText = 'Active';
                                                        // if (thisCat.status === 0) { stText = 'Deactive'; }

                                                        return <option value={users._id}> {users.firstname ? users.firstname + " " + users.lastname : ''} </option>
                                                    }) : ''
                                            }
                                        </select>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div className="col-md-12 col-xs-12">
                                <div className="form-group">
                                    <label>Outsider Delivery Boy(name, email, contact no)</label>
                                    <input
                                        type="text"
                                        onChange={(e) => this.onChange(e)}
                                        placeholder="Outsider Delivery Boy(name, email, contact no)"
                                        className="form-control"
                                        name="outsiderDeliveryBoy"
                                    />
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitDeliveryBoy(e)}>{siteConstants.LABEL_SAVE}</Button>
                        <Button variant="contained" onClick={() => this.closeDeliveryBoyPopup()}>{siteConstants.LABEL_CANCEL}</Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getAllOrders, language, getShopAndShopkeeperList, markOrderAccepted, getUsersList } = state;
    return {
        getAllOrders,
        language,
        getShopAndShopkeeperList,
        markOrderAccepted,
        getUsersList
    };
}

// const connectedCurrentOrderList = connect(mapStateToProps)(CurrentOrderList);
// export { connectedCurrentOrderList as CurrentOrderList };

export default connect(mapStateToProps)(withStyles(styles)(CurrentOrderList));